import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import api, { NoticeItem } from '../../api/common'
import * as typesAccount from '@account/store/types'
import { mapGetters } from 'vuex';

import ViewFrame from '@appbase/components/editor/ViewFrame.vue';

@Component({
    components: {
        ViewFrame
    },
    computed: {
        ...mapGetters({
            user: typesAccount.USER,
            current: typesAccount.CURRENT,
        }),
    },
})
export default class NotiPopup extends Vue {
    @Prop({ type: Boolean }) preview!: false;
    @Prop({ type: Object }) item?: NoticeItem;
    user!: account.User;

    items: NoticeItem[] = []

    getStyle(item: NoticeItem) {
        const { noticePopupType, width, height } = item
        if (noticePopupType === 1) { // 크기 지정 팝업
            return {
                width: item.width + 'px',
                height: item.height + 'px'
            }
        } else { // html 팝업
            return {}
        } 
    }

    onCloseMask() {
        this.items = []
    }

    isCookieKeyExists(key: string) {
        var expires = localStorage.getItem(key)
        if(expires){
            var res = new Date(expires)>new Date()
            if(!res){
                localStorage.removeItem(key)
            }
            return res
        }
        return false
    }

    public async reset() {
        
        const { user, preview } = this
        this.items = await api.getTodayNoticePopupList(user.comCode, preview).then(async (results) => {
            // 텍스트 알림 팝업 제외
            results = results.filter(x => x.noticePopupType != 3);
            if (!preview) {
                results = results.filter(x => !x.isDraft)
                var isExist = (results.findIndex(x => x.noticePopupId == this.item?.noticePopupId) > -1)
                if (this.item && !isExist) {

                    results.push(this.item)
                }

            } else {
                // 미리보기 모드일 경우 모든 미리보기를 제외하고 자기자신만
                var id = this.$route.query.itemId
                results = results.filter(x => x.noticePopupId===Number(id))
            }
            for (var result of results) {
                if (result.noticePopupType === 0) { // 이미지 팝업
                    var files = await api.getFiles(result.fileCode)
                    if (files.length > 0) {
                        const file = files[0]
                        result.url = file.downloadUrl
                    } else {

                    }
                }
            }
            return results.filter(x => !this.isCookieKeyExists(`pop_n${x.noticePopupId}`))
        })
    }

    async created() {
        await this.reset()
    }

    onFrameLoaded(ifrm: HTMLIFrameElement, item: NoticeItem) {
        var contentWindow = ifrm.contentWindow;

        
    }

    onClose(item: NoticeItem, doNotShow: boolean) {
        this.items = this.items.filter(x => x.noticePopupId !== item.noticePopupId)

        // 하루동안 표시 안 함 처리
        if (!this.preview && doNotShow === true) {
            // Cookie settings that you keep until today
            const date = new Date()

            // 자정으로 설정
            date.setHours(23, 59, 59, 999)
            // teams에서 Cookie set 안됨 > localstorage로 변경
            localStorage.setItem(`pop_n${item.noticePopupId}`,date.toUTCString().toString()) 
        }
        // 팝업추가 > 미리보기(저장)  > 팝업ID가 Undefinded 상태일 때 2번 저장됨
        // 해당 조건을 전부 만족하는 경우 해당 라우팅경로로 이동
        if (this.preview && !this.items.length && !this.$route.query.itemId) {
            // replace 처리
            window.location.href = window.location.href.replace("/func/noticepopup/detail?itemId=", "/func/noticepopup")
        }
    }
}